import React, { useContext, useEffect, useState } from "react";
import { Card, Button } from "react-bootstrap";
import Data from "../Data/ProtfolioData";
import Loading from "../components/common/Loading";

import { PortfolioPageContext } from "../context/PortfolioPageContextProvider";

const Portfolio = () => {
  const { portfoliopagedata, setPortfolioPageData } =
    useContext(PortfolioPageContext);

  return (
    <>
      {portfoliopagedata ? (
        <>
          <div className="container">
            <div className="row">
              {/* <div className="col-lg-3 col-12 bg-info p-0"> */}
              {portfoliopagedata.map((list, index) => (
                <>
                  <div className="col-lg-4 col-12 my-3" key={index}>
                    <Card className="col-12 p-0">
                      {list.imgName ? (
                        <Card.Img
                          variant="top"
                          src={`./static/${list.imgName}`}
                          // src={require(`../assets/${list.imgName}`).default}
                          className="img-fluid"
                          loading="lazy"
                        />
                      ) : (
                        <Card.Img
                          variant="top"
                          src={require(`../assets/logo.png`).default}
                          className="img-fluid"
                          loading="lazy"
                        />
                      )}
                      <Card.Body>
                        <Card.Title>
                          <span>{list.name}</span>
                        </Card.Title>
                        <Card.Text>
                          <span>{list.desc}</span>
                        </Card.Text>
                        <Button
                          variant="primary"
                          href={list.liveOn}
                          target="_blank"
                          className="col-lg-6 col-md-6 col-12"
                        >
                          View Project
                        </Button>
                      </Card.Body>
                    </Card>
                  </div>
                </>
              ))}
              <div className="col-lg-4 col-12 my-3">
                <Card className="col-12 p-0 d-flex justify-content-center align-items-center">
                  <Card.Body className="d-flex justify-content-center align-items-center">
                    <Button
                      variant="primary"
                      href="https://github.com/SubinAdhikari"
                      target="_blank"
                      className="col-lg-12 col-md-12 col-12"
                    >
                      See Others
                    </Button>
                  </Card.Body>
                </Card>
              </div>
              {/* </div> */}
            </div>
          </div>
        </>
      ) : (
        <Loading />
      )}
      <div className="spaceInBottom"></div>
    </>
  );
};
export default Portfolio;
